import styled from "styled-components";
const ShortUrlLoginPageDisplay = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: calc(100vh - 70px);
  .spinerC {
    min-height: 50px;
  }
`;
export default ShortUrlLoginPageDisplay;
